<template>
  <div class="coupon">
    <h3>我的优惠券</h3>
    <nav class="nav">
      <ul>
        <li :class="status === index ? 'on' : '' " v-for="(item, index) in nav" :key="index" @click="cutStatus(index)">{{item}}</li>
      </ul>
    </nav>
    <div class="content">
      <ul class="list">
        <li class="item" :class="item.status !== 0 ? 'past' : ''" v-for="(item, index) in couponList" :key="item.id" v-if="status === item.status">
          <p v-if="item.status === 2" class="grey">已过期</p>
          <p v-if="item.status === 1" class="grey">已使用</p>
          <div class="top">
            <div class="left">
              <h4>{{item.name}}</h4>
              <p class="time">有效期至{{item.expireDate}}</p>
            </div>
            <div class="right">￥<span class="price">{{item.amount}}</span></div>
          </div>
          <div class="bottom">
            <p>新用户注册</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="pagin">
      <pagination :pageCount="pageCount" @pageSize="pageSize" />
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pagination'
import {reqCoupon} from '../../../api'
export default {
  data () {
    return {
      nav: ['未使用', '已使用', '已过期'],
      couponList: [],
      pageCount: 0,
      status:0
    }
  },
  created(){
    this._reqCoupon(1, 10, 0)
  },
  methods: {
    _reqCoupon(pageIndex,pageSize=10, status) {
      reqCoupon({pageIndex, pageSize, status}).then(res => {
        if(res.code === 200) {
          this.couponList = res.data.bussData
          this.pageCount = res.data.pageCount
        }
      })
    },
    // 切换优惠状态
    cutStatus (i) {
      this.status = i
      this._reqCoupon(1, 10, i)
    },
    // 分页
    pageSize (val) {
      this._reqCoupon(val, 10, this.status)
    }
  },
  components: {
    Pagination
  }
}
</script>

<style scoped lang="less" type="text/less">
.coupon{
  h3{
    font-size: 24px;
    margin-top:60px;
  }
  .nav{
    margin-top:29px;
    padding-bottom: 40px;
    border-bottom: 1px solid #e1e1e1;
    ul{
      display: flex;
      li{
        padding:10px 19px;
        font-weight: bold;
        font-size: 16px;
        margin-right: 10px;
        cursor: pointer;
        &.on{
          background: #61aee6;
          color:#fff;
          border-radius: 18px;
        }
      }
    }
  }
  .content{
    margin-top:20px;
    .list{
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item{
        position: relative;
        width: 426px;
        height: 192px;
        padding:55px 53px 33px 64px;
        box-sizing: border-box;
        color:#fff;
        background: url("../../../assets/images/person/youhuiquan_bg.png");
        &.past{
          background: url("../../../assets/images/person/guoqi.png");
        }
        .grey{
          position: absolute;
          top: 23px;
          left: 14px;
          transform: rotate(-37deg);
        }
        .top{
          display: flex;
          justify-content: space-between;
          .left{
            h4{
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 9px;
              font-family:PingFang-SC-Bold;
            }
          }
          .right{
            font-size: 23px;
            font-weight: bold;
            .price{
              font-size: 49px;
            }
          }
        }
        .bottom{
          position: absolute;
          bottom: 33px;
          left: 50%;
          transform: translate(-50%, 0);
          p{
            font-weight: bold;
          }
        }
      }
    }
  }
  .pagin{
    margin-top:40px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Person/Children/Coupon.vue